import * as Sentry from '@sentry/react'

export function initSentry(): void {
  const dsn = import.meta.env.VITE_SENTRY_DSN
  const enabled = import.meta.env.VITE_ENABLE_SENTRY === 'true'
  if (!dsn || !enabled) return

  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: import.meta.env.PROD ? 0.15 : 1,
    beforeSend(event) {
      if (event.request?.cookies) delete event.request.cookies
      return event
    },
  })
}

export function captureSyncError(
  message: string,
  extra?: Record<string, string | number | boolean | undefined>,
): void {
  if (import.meta.env.VITE_ENABLE_SENTRY !== 'true') return
  Sentry.captureMessage(message, {
    level: 'warning',
    extra: extra as Record<string, string | number | boolean | null | undefined>,
  })
}

export function captureException(err: unknown, context?: string): void {
  if (import.meta.env.VITE_ENABLE_SENTRY !== 'true') return
  Sentry.captureException(err, context ? { tags: { context } } : undefined)
}
